(ns minorodata.components.analytics-models.run-status
  "Last-run status pill for an analytics-model instance (FT-2574).

   Renders the outcome of a model's most recent run — distinct from the
   active|paused lifecycle badge in `overview`. Takes a raw status map from the
   shared status store under `:model` (keyed :status/:is-executing/
   :finished-at), or nil when the model has never run."
  (:require [ui.date-time :refer [date-tooltip]]
            [ui.utils :refer [clsx]]))


(defn run-status-view
  "Map a run-status map (or nil) to a pill's label + colour classes.
   Colours reuse the transform status palette tokens for a consistent read."
  [status]
  (cond
    (nil? status)
    {:label "Not yet run" :text "text-kleene-text-secondary" :dot "bg-kleene-text/40"}

    (:is-executing status)
    {:label "Running…" :text "text-kleene-green" :dot "bg-kleene-green animate-kleene-pulse"}

    :else
    (case (:status status)
      "completed" {:label "Succeeded" :text "text-kleene-green"          :dot "bg-kleene-green"}
      "failed"    {:label "Failed"    :text "text-kleene-error-01"       :dot "bg-kleene-error-01"}
      "pending"   {:label "Queued"    :text "text-kleene-text-warning"   :dot "bg-kleene-text-warning"}
      "skipped"   {:label "Skipped"   :text "text-kleene-text-secondary" :dot "bg-kleene-text/40"}
      ;; Ran, but the backend returned a status this UI doesn't recognise —
      ;; "Unknown", not the nil-branch "Not yet run" (which implies never run).
      {:label "Unknown" :text "text-kleene-text-secondary" :dot "bg-kleene-text/40"})))


(defn run-status-pill
  "Compact run-status pill. Pass `{:show-time? true}` to append the finish time
   for a completed/failed run (used on the detail view, omitted in the list)."
  ([status] (run-status-pill status nil))
  ([status {:keys [show-time?]}]
   (let [{:keys [label text dot]} (run-status-view status)
         finished (:finished-at status)]
     [:span {:class (clsx "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium bg-kleene-background-secondary"
                          text)}
      [:span {:class (clsx "h-1.5 w-1.5 rounded-full shrink-0" dot)}]
      [:span label]
      (when (and show-time? finished (not (:is-executing status)))
        [:span {:class "text-kleene-text/50"} [date-tooltip {:date finished}]])])))
